<template>
    <div
        class="flex flex-col items-center justify-center py-16 px-4 text-center"
    >
        <div class="rounded-full bg-taupe-100 p-4 mb-4">
            <svg
                class="h-10 w-10 text-taupe-400"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                />
            </svg>
        </div>
        <h3 class="text-lg font-medium text-taupe-900">
            {{ title }}
        </h3>
        <p class="mt-2 text-sm text-taupe-500 max-w-md">
            {{ message }}
        </p>
        <p v-if="guidance" class="mt-3 text-sm text-taupe-400 max-w-md">
            {{ guidance }}
        </p>
        <router-link
            v-if="actionTo"
            :to="actionTo"
            class="mt-4 inline-flex items-center rounded-md bg-sky-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-sky-700"
        >
            {{ actionLabel }}
        </router-link>
    </div>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: 'Access restricted',
    },
    message: {
        type: String,
        default:
            'You don\u2019t have permission to access this feature. Contact your account administrator to request access.',
    },
    guidance: {
        type: String,
        default: null,
    },
    actionLabel: {
        type: String,
        default: 'Upgrade plan',
    },
    actionTo: {
        type: [String, Object],
        default: null,
    },
})
</script>
